<template>
	<div class="model1">
		<div>
			<div class="article_l_title">
				<!-- <img class="img1" src="../../assets/main/title_icon.jpg" alt="">
                <span>搜索</span> -->
			</div>
			<el-form
				:model="forms"
				ref="ruleForm"
				label-width="124px"
				class="demo-ruleForm"
			>
				<el-form-item
					label="关键字："
					prop="name"
					style="margin-top:20px;"
				>
					<el-input
						size="medium"
						style="width:515px;border: 1px solid #F3F3F3;"
						placeholder="请输入基金代码、名称或简称"
						v-model="forms.input1"
					></el-input>
					<span @click="searchKeyword" class="btn_search">查询</span>
					<span @click="clearKeyword" class="btn_clear">清空</span>
				</el-form-item>
				<div style="width:100%;">
					<el-form-item
						label="基金类型："
						prop="region"
						style="width:402px;display:inline-block;"
					>
						<span
							@click="clearRegion1"
							class="normalbtn clearRegion1"
							>不限</span
						>
						<el-select
							@change="changeRegion1"
							v-model="forms.region1"
							placeholder="请选择活债券类型"
							style="border: 1px solid #F3F3F3;width:82%;"
						>
							<el-option
								label="股票型"
								value="股票型"
							></el-option>
							<el-option
								label="混合型"
								value="混合型"
							></el-option>
							<el-option
								label="债券型"
								value="债券型"
							></el-option>
							<el-option
								label="指数型"
								value="指数型"
							></el-option>
							<el-option
								label="货币型"
								value="货币型"
							></el-option>
							<el-option label="QDII" value="QDII"></el-option>
							<el-option label="ETF" value="ETF"></el-option>
							<el-option
								label="联接基金"
								value="联接基金"
							></el-option>
							<el-option
								label="分级基金"
								value="分级基金"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item
						label="资产规模："
						prop="region"
						style="width:402px;display:inline-block;"
					>
						<span
							@click="clearRegion2"
							class="normalbtn clearRegion2"
							>不限</span
						>
						<el-select
							@change="changeRegion2"
							v-model="forms.region2"
							placeholder="请选择债券期限"
							style="border: 1px solid #F3F3F3;width:82%;"
						>
							<el-option
								label="小于2亿元"
								value="0-2"
							></el-option>
							<el-option label="2-5亿元" value="2-5"></el-option>
							<el-option
								label="5-10亿元"
								value="5-10"
							></el-option>
							<el-option
								label="10-20亿元"
								value="10-20"
							></el-option>
							<el-option
								label="20亿元以上"
								value="20-1000"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item
						label="地区："
						prop="region"
						style="width:402px;display:inline-block;"
					>
						<span
							@click="clearRegion3"
							class="normalbtn clearRegion3"
							>不限</span
						>
						<el-select
							@change="changeRegion3"
							v-model="forms.region3"
							placeholder="请选择省份"
							style="border: 1px solid #F3F3F3;width:82%;"
						>
							<el-option
								label="北京市"
								value="北京市"
							></el-option>
							<el-option
								label="天津市"
								value="天津市"
							></el-option>
							<el-option
								label="河北省"
								value="河北省"
							></el-option>
							<el-option
								label="山西省"
								value="山西省"
							></el-option>
							<el-option
								label="内蒙古自治区"
								value="内蒙古自治区"
							></el-option>
							<el-option
								label="辽宁省"
								value="辽宁省"
							></el-option>
							<el-option
								label="吉林省"
								value="吉林省"
							></el-option>
							<el-option
								label="黑龙江省"
								value="黑龙江省"
							></el-option>
							<el-option
								label="上海市"
								value="上海市"
							></el-option>
							<el-option
								label="江苏省"
								value="江苏省"
							></el-option>
							<el-option
								label="浙江省"
								value="浙江省"
							></el-option>
							<el-option
								label="安徽省"
								value="安徽省"
							></el-option>
							<el-option
								label="福建省"
								value="福建省"
							></el-option>
							<el-option
								label="江西省"
								value="江西省"
							></el-option>
							<el-option
								label="山东省"
								value="山东省"
							></el-option>
							<el-option
								label="河南省"
								value="河南省"
							></el-option>
							<el-option
								label="湖北省"
								value="湖北省"
							></el-option>
							<el-option
								label="湖南省"
								value="湖南省"
							></el-option>
							<el-option
								label="广东省"
								value="广东省"
							></el-option>
							<el-option
								label="广西壮族自治区"
								value="广西壮族自治区"
							></el-option>
							<el-option
								label="海南省"
								value="海南省"
							></el-option>
							<el-option
								label="重庆市"
								value="重庆市"
							></el-option>
							<el-option
								label="四川省"
								value="四川省"
							></el-option>
							<el-option
								label="贵州省"
								value="贵州省"
							></el-option>
							<el-option
								label="云南省"
								value="云南省"
							></el-option>
							<el-option
								label="西藏自治区"
								value="西藏自治区"
							></el-option>
							<el-option
								label="陕西省"
								value="陕西省"
							></el-option>
							<el-option
								label="甘肃省"
								value="甘肃省"
							></el-option>
							<el-option
								label="青海省"
								value="青海省"
							></el-option>
							<el-option
								label="宁夏回族自治区"
								value="宁夏回族自治区"
							></el-option>
							<el-option
								label="新疆维吾尔自治区"
								value="新疆维吾尔自治区"
							></el-option>
							<el-option
								label="香港特别行政区"
								value="香港特别行政区"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item
						label="发行日期："
						prop="region"
						style="width:402px;display:inline-block;"
					>
						<span
							@click="clearRegion4"
							class="normalbtn clearRegion4"
							>不限</span
						>
						<el-date-picker
							@change="changeDateFn"
							style="width:229px;border: 1px solid #F3F3F3;"
							size="large"
							v-model="dateRaneg"
							unlink-panels
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
						>
						</el-date-picker>
					</el-form-item>
				</div>
			</el-form>
		</div>
		<div class="m1_top_box">
			<h5>
				<img
					src="../../assets/main/title_icon.jpg"
					alt=""
				/>按基金类型统计基金数量 （截至{{ titleAnd1 }}）
			</h5>
			<h5>
				<img
					src="../../assets/main/title_icon.jpg"
					alt=""
				/>按发行年份统计资产规模 （截至{{ titleAnd2 }}）
			</h5>
			<div class="m1_echarts_box">
				<div class="m1_echarts1" id="m1_echarts1"></div>
				<div class="m1_echarts2" id="m1_echarts2"></div>
			</div>
		</div>
		<!-- 文章列表部分 -->
		<div class="m1_info_box">
			<div class="m1_search_box">
				<!-- <el-date-picker
                    @change="changeDateFn"
                    style="width:250px;border: 1px solid #F3F3F3;margin-left:12px;"
                    size="large"
                    v-model="dateRaneg"
                    unlink-panels
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
                <div class="m1_download_data">导出数据</div> -->
			</div>
			<ul class="m1_info_ul">
				<el-table
					v-loading="loading"
					element-loading-text="加载中"
					:empty-text="loading == true ? '加载中' : '暂无数据'"
					:fit="true"
					style="width:100%;margin:20px auto;"
					:data="dataList"
					:header-cell-style="headerCellStyle"
					:row-style="tableRowClassName"
					:cell-style="cellStyle"
					:row-key="(row) => row.FundID"
					:expand-row-keys="expandRowKeys"
					@row-click="rowClickFn"
					border
				>
					<el-table-column type="expand">
						<template slot-scope="props">
							<table class="mailTable">
								<tr>
									<td class="column">投资类型(二级分类)：</td>
									<td>{{ props.row.FundType1 }}</td>
								</tr>
								<tr>
									<td class="column">基金托管人：</td>
									<td>{{ props.row.FundTrustee }}</td>
								</tr>
								<tr>
									<td class="column">发行日期：</td>
									<td>{{ props.row.PubDate }}</td>
								</tr>
								<!-- <tr>
                                    <td class="column">基金规模：</td> 
                                    <td>{{ props.row. CreateScale }}</td>
                                </tr>   -->
								<tr>
									<td class="column">基金管理人注册城市：</td>
									<td>{{ props.row.FundManageRegion }}</td>
								</tr>
								<tr>
									<td class="column">投资范围：</td>
									<td>{{ props.row.Scope }}</td>
								</tr>
							</table>
						</template>
					</el-table-column>
					<el-table-column width="100px" label="基金代码" prop="Code">
					</el-table-column>
					<el-table-column label="基金简称" prop="ShortName">
					</el-table-column>
					<el-table-column label="基金类型" prop="FundType">
					</el-table-column>
					<el-table-column
						width="80px"
						label="资产规模(亿元)"
						prop="CapitalScaleVal"
					>
					</el-table-column>
					<el-table-column label="基金管理人" prop="FundManage">
					</el-table-column>
					<el-table-column
						label="基金管理人注册城市"
						prop="FundManageRegion"
					>
					</el-table-column>
					<el-table-column label="基金成立日" prop="CreateDate">
					</el-table-column>
				</el-table>
				<!-- <el-empty v-if="dataList.length <= 0" description="暂无数据!"></el-empty> -->
			</ul>
			<div style="font-size: 14px;float: right;">数据来源：基金公告</div>
			<div class="pagination_box">
				<el-pagination
					v-if="dataList.length > 0"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-size="pagesize"
					layout="total, prev, pager, next, jumper"
					:total="total"
				>
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import magic from '@/../static/common/magic.js';
import $ from 'jquery';
import echarts from 'echarts';

export default {
	// 绿色公募基金
	props: ['currentChoose'],
	components: {},
	data() {
		return {
			dateRaneg: [], //日期
			startDate: '', //日历开始时间
			endDate: '', //日历结束时间
			dataType: '', //时间选项 0是 一周 1 是一个月 2 是一年 不限 ''
			currentPage: 1, //当前页
			total: 0, //总页数
			pagesize: 10, //每页条数
			dataList: [], //文章列表数据
			tableColumnWidth: [], //表格各个列最大宽度
			loading: false, //表格加载
			maps: {
				bigNum: 0, //当前地图数据里的最大值
			},
			forms: {
				input1: '', //关键字查询
				region1: '', //基金类型
				region2: '',
				region3: '',
				region4: '',
				region5: '',
			},
			expandRowKeys: [], //默认展开的行id
			titleAnd1: '',
			titleAnd2: '',
		};
	},
	watch: {
		currentChoose(val) {
			this.currentPage = 1;
			this.fetchDataList(val); //获取文章列表
			this.echartsfn1();
			this.echartsfn3();
		},
		//时间段清零函数
		dateRaneg(val) {
			if (val == null) {
				this.startDate = '';
				this.endDate = '';

				this.currentPage = 1;
				this.fetchDataList(this.currentChoose);
				this.echartsfn1();
				this.echartsfn3();
			}
			//console.log(val, 'test');
		},
	},
	computed: {},
	created() {
		$('.el-range-editor.el-input__inner').css(
			'border',
			'1px solid #F3F3F3!important'
		);
	},
	mounted() {
		setTimeout(() => {
			$('.el-range-editor--small.el-input__inner').css(
				'border',
				'1px solid #F3F3F3'
			);
			$('.el-pagination__editor.el-input .el-input__inner').css(
				'border',
				'1px solid #E6E6E6!important'
			);
			$('.el-range-editor.el-input__inner').css(
				'border',
				'1px solid #F3F3F3!important'
			);
		}, 2000);

		this.fetchDataList(this.currentChoose);

		this.echartsfn1();
		this.echartsfn3();
	},
	methods: {
		//table行的点击事件
		rowClickFn(row, column, event) {
			//console.log(row, 'row');
			if (this.expandRowKeys.includes(row.FundID)) {
				this.expandRowKeys = this.expandRowKeys.filter(
					(val) => val !== row.FundID
				);
			} else {
				this.expandRowKeys.push(row.FundID);
			}
			//console.log(this.expandRowKeys, 'test table');
		},
		//债券类型切换
		changeRegion1(val) {
			$('.clearRegion1').addClass('active');
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//债券类型清除
		clearRegion1() {
			$('.clearRegion1').removeClass('active');
			this.forms.region1 = '';
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//债券期限切换
		changeRegion2(val) {
			$('.clearRegion2').addClass('active');
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//债券期限清除
		clearRegion2() {
			$('.clearRegion2').removeClass('active');
			this.forms.region2 = '';
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//省份切换
		changeRegion3(val) {
			$('.clearRegion3').addClass('active');
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//省份清除
		clearRegion3() {
			$('.clearRegion3').removeClass('active');
			this.forms.region3 = '';
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//时间清除
		clearRegion4() {
			$('.clearRegion4').removeClass('active');
			this.startDate = '';
			this.endDate = '';
			this.dateRaneg = [];
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//点击关键字查询
		searchKeyword() {
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
		//点击关键字清除
		clearKeyword() {
			this.forms.input1 = '';
			this.fetchDataList(this.currentChoose);
			this.echartsfn1();
			this.echartsfn3();
		},
	//table的单元格样式
  cellStyle(row, column, rowIndex, columnIndex) {
			//styles
			let _this = this;
			if (row.rowIndex % 2 == 0) {
				return 'background:#fff;';
			} else {
				return 'background:#F5F7F5;';
			}
			// if (row.rowIndex == 0) {
			//     return "color: #333333;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;display:none;";
			// }
		},
		//获取表格每一列的文字最大长度
		getMaxTableWidthFn(data) {
			let _this = this;
			let tmpLen = Object.keys(data[0]).length;
			let arr = [];
			for (let i = 0; i < tmpLen; i++) {
				arr.push([]);
			}
			for (let i = 0; i < data.length; i++) {
				for (let item in data[i]) {
					let len = _this.chkstrlen(String(data[i][item]));
					arr[item].push(len);
				}
			}
			_this.tableColumnWidth = [];
			for (let i = 0; i < arr.length; i++) {
				_this.tableColumnWidth.push(Math.max(...arr[i]));
			}
		},
		//判断是否是汉字
		chkstrlen(str) {
			let strlen = 0;
			for (let i = 0; i < str.length; i++) {
				if (str.charCodeAt(i) > 255) {
					//如果是汉字，则字符串长度加2
					strlen += 2;
				} else {
					strlen++;
				}
			}
			return strlen;
		},
		// table表格样式
		headerCellStyle({ row, rowIndex }) {
			return 'background:#F5F7F5;color:#222222;';
		},
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 0) {
				return 'background:#F5F7F5!important;';
			}
			return '';
		},
		// 饼图1
		echartsfn1() {
			var chartDom = document.getElementById('m1_echarts1');
			var myChart = echarts.init(chartDom);
			var option;

			option = {
				// title: {
				//     text: 'Referer of a Website',
				//     subtext: 'Fake Data',
				//     left: 'center'
				// },
				color: ['#ebdecb', '#8aa87d', '#7d97a8'],
				grid: {
					left: '1%',
					right: '1%',
					bottom: '4%',
					top: '3%',
					containLabel: true,
				},
				tooltip: {
					trigger: 'item',
					formatter: function(params) {
						return `${params.marker}${params.name} : ${params.value} 只`;
					},
				},
				// legend: {
				//     orient: 'vertical',
				//     left: 'left'
				// },
				series: [
					{
						// name: 'Access From',
						type: 'pie',
						radius: '50%',
						data: [
							{ value: 1048, name: 'Search Engine' },
							{ value: 735, name: 'Direct' },
						],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)',
							},
						},
					},
				],
			};

			let params = {
				pagesize: this.pagesize,
				curpage: this.currentPage,
				keyWords: this.forms.input1,
				fundType: this.forms.region1,
				bondTerm: this.forms.region2,
				province: this.forms.region3,
				issueStartDate: this.startDate,
				issueEndDate: this.endDate,
				categoryIndustry: '',
				majorIndustry: '',
			};
			let _this = this;
			api.getPublicFundByType(params).then((res) => {
				option.series[0].data = res.data.data;
				_this.titleAnd1 = res.data.endDate;
				option && myChart.setOption(option);
			});
		},
		// 柱状图1
		echartsfn3() {
			var chartDom = document.getElementById('m1_echarts2');
			var myChart = echarts.init(chartDom);
			var option;

			option = {
				// dataZoom: [
				// 	{
				// 		start: 0,
				// 		end: 20,
				// 		height: 16,
				// 	},
				// ],
				tooltip: {
					show: true,
					trigger: 'axis',
					formatter: '{b}： {c} 亿元',
				},
				color: ['#42A15B'],
				grid: {
					left: '2%',
					right: '2%',
					bottom: '16%',
					top: '3%',
					containLabel: true,
				},
				xAxis: {
					type: 'category',
					data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				series: [
					{
						data: [120, 200, 150, 80, 70, 110, 130],
						type: 'bar',
						barWidth: 14,
						showBackground: true,
						backgroundStyle: {
							color: 'rgba(180, 180, 180, 0.2)',
						},
					},
				],
			};

			let params = {
				pagesize: this.pagesize,
				curpage: this.currentPage,
				keyWords: this.forms.input1,
				fundType: this.forms.region1,
				bondTerm: this.forms.region2,
				province: this.forms.region3,
				issueStartDate: this.startDate,
				issueEndDate: this.endDate,
				categoryIndustry: '',
				majorIndustry: '',
			};
			let _this = this;
			api.getPublicFundByYear(params).then((res) => {
				option.series[0].data = res.data.data['yList'];
				option.xAxis.data = res.data.data['xList'];
				_this.titleAnd2 = res.data.endDate;
				option && myChart.setOption(option);
			});
		},
		// 点击日历切换函数
		changeDateFn(res) {
			if (this.dateRaneg.length > 0) {
				let startDate = magic.TimestampToDateTime(res[0]);
				let endDate = magic.TimestampToDateTime(res[1]);

				startDate
					? (this.startDate = startDate.substring(0, 10))
					: (this.startDate = '');
				endDate
					? (this.endDate = endDate.substring(0, 10))
					: (this.endDate = '');

				this.currentPage = 1;
				this.fetchDataList(this.currentChoose);
				this.echartsfn1();
				this.echartsfn3();

				$('.clearRegion4').addClass('active');
			}
		},
		//获取表格数据
		fetchDataList(_id) {
			let _this = this;
			//{"pagesize":5,"curpage":1,"keyWords":"关键字","fundType":"债券类型","bondTerm":"债券期限","province":"省份","issueStartDate":"发行日期",issueEndDate":"结束日期","categoryIndustry":"证监会行业门类","majorIndustry":"大类"}
			// let params = {"indexId":_id,"pagesize":this.pagesize,"curpage":this.currentPage,"start":this.startDate,"end":this.endDate,"type":"0"};
			let params = {
				pagesize: this.pagesize,
				curpage: this.currentPage,
				keyWords: this.forms.input1,
				fundType: this.forms.region1,
				bondTerm: this.forms.region2,
				province: this.forms.region3,
				issueStartDate: this.startDate,
				issueEndDate: this.endDate,
				categoryIndustry: '',
				majorIndustry: '',
			};
			this.loading = true;
			api.getGraphListData5(params).then((res) => {
				//console.log(res, 'list');

				_this.dataList = res.data.rows;
				// _this.getMaxTableWidthFn(res.data.rows);
				_this.total = res.data.total;
				setTimeout(() => {
					_this.loading = false;
				}, 100);
			});
		},
		//翻页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.fetchDataList(this.currentChoose);
		},
	},
	filters: {
		subData1: function(value) {
			return value.substring(0, 7);
		},
		subData2: function(value) {
			return value.substring(8, 10);
		},
	},
};
</script>
<style scoped lang="less">
.model1 {
	width: 890px;
	height: 100%;
	overflow: hidden;
	padding: 14px 30px;
	background: #fff;
}

.m1_top_box {
	width: 100%;
	overflow: hidden;
	position: relative;
}

.m1_echarts_alert {
	width: 313px;
	height: 196px;
	background: #ffffff;
	border: 1px solid #dbdbdb;
	box-shadow: 0px 0px 27px 0px rgba(190, 193, 189, 0.75);
	border-radius: 2px;
	position: absolute;
	bottom: 0;
	left: 0;
	z-index: 1000;
	// display: none;
}
.m1_echarts_bar_close {
	position: absolute;
	bottom: 181px;
	left: 299px;
	display: block;
	width: 25px;
	height: 25px;
	border: 1px solid #ccc;
	z-index: 200000;
	text-align: center;
	line-height: 26px;
	border-radius: 50%;
	background: #fff;
	cursor: pointer;
}
.m1_top_box {
	width: 100%;
	overflow: hidden;
}
.m1_top_box h5 {
	width: 420px;
	height: 50px;
	line-height: 50px;
	float: left;
	border-bottom: 1px solid #e7ede5;
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #222222;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
}
.m1_top_box h5:first-child {
	margin-right: 40px;
}
.m1_top_box h5 img {
	height: 18px;
	display: inline-block;
	margin-right: 5px;
	vertical-align: middle;
}
.m1_echarts_box {
	width: 100%;
	overflow: hidden;
	margin-top: 85px;
	display: flex;
	justify-content: space-evenly;
}
.m1_echarts1 {
	width: 410px;
	height: 280px;
	float: left;
}
.m1_echarts2 {
	width: 400px;
	height: 280px;
	float: right;
}
//文章列表部分
.m1_info_box {
	width: 100%;
	overflow: hidden;
	position: relative;
}
.m1_info_box h5 {
	width: 100%;
	height: 70px;
	line-height: 70px;
	border-bottom: 1px solid #e7ede5;
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #222222;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	margin-top: 30px;
}
.m1_info_box h5 img {
	height: 18px;
	display: inline-block;
	margin-right: 5px;
	vertical-align: middle;
}
// 搜索框部分
.m1_search_box {
	width: 100%;
	line-height: 32px;
	margin-top: 22px;
	overflow: hidden;
}
.m1_download_data {
	width: 100px;
	height: 36px;
	background: #4eac41;
	border-radius: 1px;
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #ffffff;
	text-align: center;
	line-height: 36px;
	display: inline-block;
	float: right;
	cursor: pointer;
}

.el-range-editor.el-input__inner {
	border: 1px solid #e7ede5 !important;
}
.m1_info_ul {
	width: 100%;
	overflow: hidden;
	margin-top: 16px;
}

// table样式
.el-table .row_yellow {
	background: #f5f7f5 !important;
}
.mailTable {
	font-size: 14px;
	color: #4b4b4b;
	width: 100%;
	font-family: Microsoft YaHei;
	background: rgb(245, 247, 245);
}
.mailTable tr {
	background: rgb(245, 247, 245);
}
.mailTable tr td.column {
	background-color: rgba(78, 172, 65, 0.15);
	// color: #dfecf7;
	font-size: 14px;
	font-weight: 700;
	width: 20%;
}
.mailTable tr td {
	border: 1px solid rgb(235, 238, 245);
	width: 80%;
	height: 35px;
	line-height: 35px;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	padding: 0 10px;
	// color: #dfecf7;
}

// 分页
.pagination_box {
	width: 100%;
	overflow: hidden;
	margin-bottom: 70px;
	margin-top: 50px;
	text-align: right;
}

// forms
.btn_search {
	width: 74px;
	height: 36px;
	background: #328046;
	border-radius: 1px;
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #ffffff;
	display: inline-block;
	text-align: center;
	line-height: 36px;
	margin-left: 10px;
	cursor: pointer;
}
.btn_clear {
	width: 74px;
	height: 36px;
	background: #c7cbc6;
	border-radius: 1px;
	display: inline-block;
	text-align: center;
	line-height: 36px;
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #ffffff;
	cursor: pointer;
}
.normalbtn {
	width: 42px;
	height: 40px;
	background: #328046;
	border-radius: 1px;
	display: inline-block;
	text-align: center;
	line-height: 40px;
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #ffffff;
	cursor: pointer;
}
.normalbtn.active {
	background: #b9c5d9;
	color: #fff;
}
.article_l_title {
	width: 100%;
	height: 32px;
	line-height: 32px;
	overflow: hidden;
	border-bottom: 1px solid #e6e6e6;
	margin-top: 20px;
}
.article_l_title .img1 {
	width: 3px;
	display: inline-block;
	margin-right: 7px;
	float: left;
}
.article_l_title span {
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #222222;
	float: left;
	display: inline-block;
	line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/view/lvcolumn/mode2.vue